// extracted by mini-css-extract-plugin
export default {"branchContainer":"FoodReviewPage_branchContainer__RR9dY"};